import React from "react";
import { isEmpty } from "lodash";

import { OnlineLink, Skeleton } from "components";
import { useLoader } from "hooks";

import styles from "./residualsModal.module.scss";

type ChangesRowProps = {
	changesType: string;
	labelCurrent: string;
	labelNew: string;
	linkCurrent: string;
	linkNew: string;
	isLoading: boolean;
};

const ChangesRow = ({
	changesType,
	labelCurrent,
	labelNew,
	linkCurrent,
	linkNew,
	isLoading,
}: ChangesRowProps) => {
	const Loader = useLoader(isLoading);

	return (
		<div className={styles.changesRow}>
			{changesType} was changed from{" "}
			<Loader
				skeleton={
					<Skeleton
						variant="text"
						height="10px"
						maxWidth="50px"
						className="d-inline-block"
					/>
				}
				component={
					!isEmpty(linkCurrent) ? (
						<OnlineLink
							to={linkCurrent}
							target="_blank"
							title={labelCurrent}
						>
							{labelCurrent}
						</OnlineLink>
					) : (
						<span className="text-white">{labelCurrent}</span>
					)
				}
			/>{" "}
			to{" "}
			<Loader
				skeleton={
					<Skeleton
						variant="text"
						height="10px"
						maxWidth="50px"
						className="d-inline-block"
					/>
				}
				component={
					!isEmpty(linkNew) ? (
						<OnlineLink
							to={linkNew}
							target="_blank"
							title={labelNew}
						>
							{labelNew}
						</OnlineLink>
					) : (
						<span className="text-white">{labelNew}</span>
					)
				}
			/>
		</div>
	);
};

export default ChangesRow;
